import { motion } from "framer-motion";
import { Gift } from "lucide-react";

export default function VoucherSection() {
  return (
    <section
      id="gutscheine"
      data-testid="voucher-section"
      className="py-20 bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          className="relative overflow-hidden border border-[#C9A84C]/40 bg-[#141414] p-10 md:p-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          {/* Background glow */}
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_right,rgba(201,168,76,0.08)_0%,transparent_60%)]" />

          {/* Corner decoration */}
          <div className="absolute top-0 right-0 w-32 h-32 border-t border-r border-[#C9A84C]/20" />
          <div className="absolute bottom-0 left-0 w-32 h-32 border-b border-l border-[#C9A84C]/20" />

          <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-8">
            <div className="flex items-start gap-6">
              <div className="bg-[#C9A84C]/10 border border-[#C9A84C]/30 p-4 flex-shrink-0">
                <Gift size={32} className="text-[#C9A84C]" strokeWidth={1.5} />
              </div>
              <div>
                <h2 className="font-cormorant text-3xl md:text-4xl italic text-[#F0F0F0] mb-3">
                  Das perfekte Geschenk
                </h2>
                <p className="text-[#C9A84C] text-sm font-outfit font-semibold tracking-wide mb-2">
                  Royal Tattoo Gutscheine
                </p>
                <p className="text-[#888888] text-sm font-outfit leading-relaxed max-w-md">
                  Erhältlich direkt in unseren Studios. Ideal für Geburtstage,
                  Weihnachten &amp; besondere Anlässe — ein Erlebnis, das bleibt.
                </p>
              </div>
            </div>

            <a
              href="#kontakt"
              data-testid="voucher-cta"
              className="gold-btn-solid whitespace-nowrap flex-shrink-0"
            >
              Gutschein anfragen
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
